var DefaultHeader = require("./DefaultHeader");

/**
 * Content view for showing views that require full screen display (regardless of screen size)
 * and non-resources headers.
 *
 * @constructor
 */
function FullScreenContentView() {
    var self = this;

    var currentView;

    var views = [];
    var viewCount = 0;

    /** @type {jQuery} */
    var $content = $("#fullScreenContent");

    /** @type {DefaultHeader} */
    var header = new DefaultHeader();

    $content.closest("[data-role=page]").append(header.getContent());

    /**
     * Sets the specified view to be the one currently displayed by the content view.
     * Note: The view will not be visible until the content view itself is also visible.
     *
     * @param {AbstractView} view - The view to be displayed
     */
    this.setView = function(view) {
        // Get header config from view and update header accordingly
        header.configure(view.getHeaderConfiguration());

        view.show();
        currentView = view;
    };

    /**
     * Adds the content of the specified view to the container element for this content view
     *
     * @param {AbstractView} view - The view to be added to the content view
     */
    this.addView = function(view) {
        view.hide();
        $content.append(view.getContent());
        views[viewCount++] = view;
    };

    /**
     * Shows the content view and its header
     */
    this.show = function() {
        header.show();
        $content.show();
        self.resize($content.innerWidth(), $content.innerHeight());
    };

    /**
     * Hides the content view and its header
     */
    this.hide = function() {
        header.hide();

        if (currentView) {
            currentView.hide();
        }
        $content.hide();
    };

    this.resize = function(width, height) {
        header.resize(width);

        if (currentView) {
            currentView.resize(width, height - header.getContent().outerHeight());
        }
    };
}

module.exports = FullScreenContentView;